export default __webpack_public_path__ + "static/media/OMAR_TENORIO.2a9147dd.png";